/*
 * JANGIN Heat Check — leaderboard.
 *
 * Reads the public leaderboard function once on load and draws last month's
 * podium ("The October Podium", the most recent CLOSED challenge), then the
 * year's standings.
 * Every string from the server goes in with textContent, never innerHTML:
 * display names are typed by entrants.
 *
 * States on the section: loading → ready | empty | error.
 */
(function () {
  var section = document.querySelector('.jangin-challenge-leaderboard');
  if (!section) return;

  var endpoint = section.dataset.endpoint;
  var q = function (sel) { return section.querySelector(sel); };
  var empty = q('[data-cl-empty]');
  var error = q('[data-cl-error]');
  var boards = q('[data-cl-boards]');
  var podiumBlock = q('[data-cl-podium-block]');
  var labels = podiumBlock.dataset;

  var hideEmpty = section.dataset.hideEmpty === 'true';

  function setState(s) {
    section.setAttribute('data-state', s);
    empty.hidden = s !== 'empty' && s !== 'loading';
    error.hidden = s !== 'error';
    boards.hidden = s !== 'ready';
    // Nothing to show yet, or the feed is down: with hide_when_empty the
    // section stays out of sight rather than showing an empty board.
    if (hideEmpty) section.hidden = s !== 'ready';
  }

  // 🔴 Sample standings for demos before launch. Never on the published theme:
  // Shopify.theme.role is 'main' there and 'unpublished' on staging. The go-live
  // script also switches the setting off. Scores follow the real rules (a
  // month maxes at 1,100: 200 + 4 x 100 + a 500 judged pick; the year adds a
  // 150 streak bonus after 3 months in a row).
  var theme = window.Shopify && window.Shopify.theme;
  var demo = section.dataset.demo === 'true' && !!theme && theme.role !== 'main';
  function p(place, rank, name, handle, points) {
    return { place: place, rank: rank, name: name, handle: handle, points: points };
  }
  var SAMPLE = {
    state: 'running',
    challenge: { number: 4, starts_on: '2027-01-14', ends_on: '2027-02-10' },
    months: [
      { number: 4, starts_on: '2027-01-14', ends_on: '2027-02-10', status: 'running',
        podium: [p(1, 1, 'Mina K.', 'mina.cooks', 1100), p(2, 2, 'Daniel R.', 'dan_eats', 1000), p(3, 3, null, 'seoulfoodie', 800)] },
      { number: 3, starts_on: '2026-12-10', ends_on: '2027-01-13', status: 'final',
        podium: [p(1, 1, 'Daniel R.', 'dan_eats', 1100), p(2, 2, 'Priya S.', 'priyainthekitchen', 900), p(3, 3, 'Marcus T.', 'marcus.grills', 800)] },
      { number: 2, starts_on: '2026-11-12', ends_on: '2026-12-09', status: 'final',
        podium: [p(1, 1, 'Priya S.', 'priyainthekitchen', 1000), p(2, 2, 'Mina K.', 'mina.cooks', 800), p(3, 3, null, 'seoulfoodie', 700)] },
      { number: 1, starts_on: '2026-10-08', ends_on: '2026-11-11', status: 'final',
        podium: [p(1, 1, 'Daniel R.', 'dan_eats', 900), p(2, 2, 'Jess L.', 'jess_eats_nyc', 700), p(3, 3, 'Mina K.', 'mina.cooks', 600)] }
    ],
    year: [
      { rank: 1, name: 'Daniel R.', handle: 'dan_eats', points: 3450 },
      { rank: 2, name: 'Mina K.', handle: 'mina.cooks', points: 3150 },
      { rank: 3, name: 'Priya S.', handle: 'priyainthekitchen', points: 2550 },
      { rank: 4, name: null, handle: 'seoulfoodie', points: 2300 },
      { rank: 5, name: 'Marcus T.', handle: 'marcus.grills', points: 1950 },
      { rank: 6, name: 'Jess L.', handle: 'jess_eats_nyc', points: 1750 },
      { rank: 7, name: 'Ana G.', handle: 'ana.cocina', points: 1350 },
      { rank: 8, name: null, handle: 'hungryinhoboken', points: 1100 },
      { rank: 9, name: 'Keiko M.', handle: 'keiko.home', points: 950 },
      { rank: 10, name: 'Tom B.', handle: 'tombakes', points: 800 }
    ],
    updated_at: '2027-01-28T23:15:00Z'
  };

  // "2026-10-08" -> "October 8". Built from the parts, not new Date(), which
  // would read the string as UTC midnight and show October 7 across the US.
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
    'August', 'September', 'October', 'November', 'December'];
  function day(iso) {
    var d = iso.split('-');
    return MONTHS[+d[1] - 1] + ' ' + (+d[2]);
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  // Registered entrants chose a leaderboard name; the handle underneath is what
  // lets anyone find the posts. Unregistered entrants ARE their handle, so it is
  // not repeated. Sample handles may belong to real strangers on Instagram, so
  // in demo mode they are plain text, never links.
  function handleEl(r, cls) {
    var h = el(demo ? 'span' : 'a', cls, '@' + r.handle);
    if (!demo) {
      h.href = 'https://www.instagram.com/' + encodeURIComponent(r.handle) + '/';
      h.target = '_blank';
      h.rel = 'noopener';
    }
    return h;
  }

  function pts(n) { return Number(n).toLocaleString('en-US') + ' pts'; }

  // ---- Year list ------------------------------------------------------------
  function row(r) {
    var li = el('li', 'jangin-challenge-leaderboard__row');
    li.appendChild(el('span', 'jangin-challenge-leaderboard__rank', r.rank));
    var who = el('span', 'jangin-challenge-leaderboard__who');
    who.appendChild(el('span', 'jangin-challenge-leaderboard__name', r.name || '@' + r.handle));
    if (r.name) who.appendChild(handleEl(r, 'jangin-challenge-leaderboard__handle'));
    li.appendChild(who);
    li.appendChild(el('span', 'jangin-challenge-leaderboard__points', pts(r.points)));
    return li;
  }

  // ---- Last month's podium --------------------------------------------------
  // Drawn 2nd, 1st, 3rd from left to right, the way a podium stands. An empty
  // place (fewer than three people scored) keeps its step so the shape holds.
  function place(entry, n) {
    var col = el('div', 'jangin-challenge-leaderboard__place jangin-challenge-leaderboard__place--' + n);
    col.setAttribute('role', 'listitem');
    var who = el('div', 'jangin-challenge-leaderboard__place-who');
    if (entry) {
      var nm = el('span', 'jangin-challenge-leaderboard__place-name', entry.name || '@' + entry.handle);
      nm.title = nm.textContent;
      who.appendChild(nm);
      if (entry.name) {
        var hd = handleEl(entry, 'jangin-challenge-leaderboard__place-handle');
        hd.title = hd.textContent;
        who.appendChild(hd);
      }
      who.appendChild(el('span', 'jangin-challenge-leaderboard__place-points', pts(entry.points)));
      if (entry.rank < entry.place) who.appendChild(el('span', 'jangin-challenge-leaderboard__place-tied', labels.tied));
    } else {
      who.appendChild(el('span', 'jangin-challenge-leaderboard__place-name jangin-challenge-leaderboard__place-name--open', '—'));
    }
    col.appendChild(who);
    col.appendChild(el('div', 'jangin-challenge-leaderboard__step', n));
    return col;
  }

  // A challenge is named for the month it opens in: October 8 to November 11
  // is the October podium.
  function renderPodium(m) {
    var month = MONTHS[+m.starts_on.split('-')[1] - 1];
    q('[data-cl-podium-title]').textContent = labels.title.replace('{month}', month);
    q('[data-cl-podium-dates]').textContent = day(m.starts_on) + ' to ' + day(m.ends_on);
    var byPlace = {};
    (m.podium || []).forEach(function (e) { byPlace[e.place] = e; });
    var stand = q('[data-cl-podium]');
    stand.textContent = '';
    [2, 1, 3].forEach(function (n) { stand.appendChild(place(byPlace[n], n)); });
  }

  function render(data) {
    // Last month: the newest CLOSED challenge with scores (months arrives
    // newest first). The month still running is not done, so it never gets a
    // podium; before the first challenge closes there is none at all.
    var last = (data.months || []).filter(function (m) {
      return m.status !== 'running' && m.podium && m.podium.length;
    })[0];
    var year = data.year || [];
    if (!year.length) return setState('empty');

    if (last) renderPodium(last);
    podiumBlock.hidden = !last;
    var yearEl = q('[data-cl-year]');
    yearEl.textContent = '';
    year.forEach(function (r) { yearEl.appendChild(row(r)); });

    if (data.updated_at) {
      var t = new Date(data.updated_at).toLocaleString('en-US', {
        timeZone: 'America/New_York', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit'
      });
      q('[data-cl-updated]').textContent = ' Updated ' + t + ' ET.';
    }
    setState('ready');
  }

  setState('loading');
  if (demo) {
    render(SAMPLE);
    q('[data-cl-demo]').hidden = false;
    return;
  }
  fetch(endpoint, { headers: { Accept: 'application/json' } })
    .then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    })
    .then(render)
    .catch(function () { setState('error'); });
})();
